/** Coordinates first paint after HTML boot splash so PageEnter does not flash white. */

let skipPageEnterOnce = false;

export const markBootReveal = () => {
  skipPageEnterOnce = true;
};

export const consumeSkipPageEnter = () => {
  if (!skipPageEnterOnce) return false;
  skipPageEnterOnce = false;
  return true;
};
